import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { logCustomEvent } from '~/api/analytics';
import browserHistory from '~/browserHistory';
import { apiMethods } from '~/services/api';
import { apiMethodsConst } from '~/services/methods';
import { jobKeys } from '../jobKeys';

export interface IDeclineCandidatePayload {
  jobId: string;
  counterOfferId: string;
  cancellation_reason: string;
  candidateId: string;
  nextCandidateId?: string | null;
}

type TDeclineCandidateResponse = {
  isOnsiteInterview?: boolean;
  [key: string]: unknown;
};
type TDeclineCandidateError = AxiosError<{ message?: string; error?: string; title?: string }>;

export function useDeclineCandidateMutation() {
  const queryClient = useQueryClient();

  return useMutation<TDeclineCandidateResponse, TDeclineCandidateError, IDeclineCandidatePayload>({
    mutationFn: async ({ jobId, counterOfferId, cancellation_reason }) => {
      return await apiMethods[apiMethodsConst.DECLINE_COUNTER_OFFER_REQUEST]({
        jobId,
        counterOfferId,
        cancellation_reason,
      });
    },
    onSuccess: async (response, variables) => {
      const { jobId, counterOfferId, candidateId, nextCandidateId } = variables;

      void logCustomEvent('decline_candidate', {
        jobId,
        counterOfferId,
        candidateId,
      });

      queryClient.invalidateQueries({ queryKey: ['dashboard-jobs'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard-jobs-info'] });
      queryClient.invalidateQueries({ queryKey: jobKeys.detail(jobId) });
      queryClient.invalidateQueries({ queryKey: jobKeys.candidates(jobId) });

      if (response?.isOnsiteInterview) {
        return;
      }

      if (nextCandidateId) {
        browserHistory.replace(`/dashboard/job/${jobId}/confirm/${nextCandidateId}`, {
          fromDeclineCandidate: true,
        });
      } else {
        browserHistory.replace(`/dashboard/job/${jobId}`);
      }
    },
  });
}
